// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"172":"886dc5","188":"821779","940":"ea0d31"}[chunkId] + ".js";
};